<template>
  <div>
    <select v-model="selected" class="form-select" :class="setClasses" @change="changeValue" placeholder="casa">
      <slot></slot>
    </select>
  </div>
</template>

<script>
export default {
  name: 'base-select',
  inheritAttrs: false,
  props: {
    value: {
      type: [Number, String, Boolean],
      required: false
    },
    size: {
      type: String,
      default: 'none'
    }
  },
  data: function () {
    return {
      selected: null
    }
  },
  computed: {
    setClasses: function () {
      return {
        'h-8 py-1 text-sm': this.size === 'tiny'
      }
    }
  },
  methods: {
    changeValue: function () {
      this.$emit('input', this.selected)
    }
  },
  watch: {
    value: {
      immediate: true,
      handler: function (value) {
        this.selected = value
      }
    }
  }
}
</script>

<style lang="sass" scoped></style>
